module.exports = __webpack_public_path__ + "static/Bandit-041d52447f97f7cce7045786483521cd.jpg";